
import DragAndDrop from './DragDrop';
import Slider from './Slider';

export const StateCredentialFile = ({
  // editMode,
  credential,
  license,
  setLicenses,
  credentialType,
// eslint-disable-next-line arrow-body-style
}) => {
  /** this component will used later for credential-service v2 integration
  if (FF) {
    return (
      <StateCredentialFileV2
        editMode={editMode}
        credential={credential}
        license={license}
        setLicenses={setLicenses}
        credentialType={credentialType}
      />
    );
  }
  */

  return (
    <div
      style={{
        border: '1px dashed #cecece',
        borderRadius: '5px',
        fontWeight: 400,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexDirection: 'column',
      }}
    >
      {credential && credential?.files?.length > 0 ? (
        <Slider
          credential={credential}
          license={license}
          setLicenses={setLicenses}
          credentialType={credentialType}
        />
      ) : (
        <DragAndDrop
          credential={credential}
          license={license}
          setLicenses={setLicenses}
          credentialType={credentialType}
        />
      )}
    </div>
  );
};
